import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {DraftRepositoriesFactory} from '../Repositories/factory.js'

class GetFreeAdsAvailableAdPublisherUseCase extends UseCase {
  #getCurrentUserService
  #repository
  #userNotLoggedInUserError

  constructor({config}) {
    super()
    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({config})
    this.#repository = DraftRepositoriesFactory.hTTPDraftRepository({config})
    this.#userNotLoggedInUserError = UserErrorsFactory.userNotLoggedInUserError
  }

  static create({config}) {
    return new GetFreeAdsAvailableAdPublisherUseCase({config})
  }

  @tracer({metric: 'GetFreeAdsAvailableAdPublisherUseCase#execute'})
  @AsyncInlineError()
  async execute() {
    const userEntity = await this.#getCurrentUserService.execute()

    if (!userEntity) {
      return Promise.reject(
        this.#userNotLoggedInUserError({
          message: '[RenewAdPublisherUseCase#execute] User not logged in'
        })
      )
    }

    const [error, freeAdsVO] = await this.#repository.getFreeAdsAvailable({userEntity})

    if (error) return Promise.reject(error)

    return freeAdsVO.toJSON()
  }
}

export const factory = GetFreeAdsAvailableAdPublisherUseCase.create
